import React, { useState} from 'react';
import { Mail, Phone, MapPin, Contact } from 'lucide-react';
import ContactFormModal from './ContactFormModal';

const Footer = () => {
  const [showContactForm, setShowContactForm] = useState(false);

  return (
    <footer className="bg-purple-900 text-white py-12 mt-20">
      <div className="container mx-auto px-4">
        {/* Section principale */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Colonne 1 - À propos */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Alaia Cristal Bien-être</h3>
            <p className="text-purple-200 text-sm leading-relaxed">
              Massages de bien-être, réalisés sans visée thérapeutique, médicale ou sexuelle. 
              Les pierres sont utilisées dans le respect de la lithothérapie.
            </p>
          </div>

          {/* Colonne 2 - Contact */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-purple-200 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>21 Rue des Charmes, 79000 Bessines (Spa Eclipsea)</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>06.47.13.93.04</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>alaia.cristalbienetre@gmail.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Contact className="w-5 h-5 flex-shrink-0" />
                <button
                  onClick={() => setShowContactForm(true)}
                  className="text-purple-200 hover:text-white text-sm transition-colors"
                >
                  Nous contacter
                </button>
              </div>
            </div>
          </div>

          {/* Colonne 3 - Horaires */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Horaires</h3>
            <div className="text-purple-200 text-sm space-y-2">
              <p><strong>Mardi :</strong> 14h00 - 20h00</p>
              <p><strong>Mercredi - Vendredi :</strong> 11h00 - 20h00</p>
              <p><strong>Samedi :</strong> 10h00 - 18h00</p>
              <p className="text-xs mt-4 italic">Fermé le lundi et dimanche. Prestation sur rendez-vous uniquement</p>
            </div>
          </div>
        </div>

        {/* Séparateur */}
        <div className="border-t border-purple-700 my-8"></div>

        {/* Liens légaux */}
        <div className="flex flex-wrap justify-center gap-6 mb-6">
          <a href="/mentions-legales" className="text-purple-200 hover:text-white text-sm transition-colors">
            Mentions légales
          </a>
          <a href="/politique-confidentialite" className="text-purple-200 hover:text-white text-sm transition-colors">
            Politique de confidentialité
          </a>
          <a href="/politique-cookies" className="text-purple-200 hover:text-white text-sm transition-colors">
            Politique de cookies
          </a>
          <a href="/cgv" className="text-purple-200 hover:text-white text-sm transition-colors">
            CGV
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-purple-300 text-sm">
            © {new Date().getFullYear()} Alaia Cristal Bien-être - Tous droits réservés
          </p>
        </div>
      </div>

      {showContactForm && (
        <ContactFormModal onClose={() => setShowContactForm(false)} />
      )}
    </footer>
  );
};

export default Footer;